// extracted by mini-css-extract-plugin
export default {"subTabs":"ProfileOportunidades_subTabs__7498T","subTab":"ProfileOportunidades_subTab__ALGdL","subTabActive":"ProfileOportunidades_subTabActive__5AATO"};